import { z } from 'zod';
import type { SignInFormSoftValues } from './types';
import { passwordRequiredMsg } from '../SignInForm/constants';
import { buildErrorObject } from '@libs/common-next';

export const SignInFormSoftSchema = z
    .object({
        password: z.string().trim().min(1, passwordRequiredMsg),
    })
    .strict();

export const validateSignInFormSoft = (
    values: SignInFormSoftValues
): { [key: string]: string[] | undefined } | undefined => {
    const result = SignInFormSoftSchema.safeParse(values);

    if (!result.success) {
        return buildErrorObject(result.error.errors);
    }
};
